import { render, staticRenderFns } from "./DebtTabs.vue?vue&type=template&id=48a151d2&"
import script from "./DebtTabs.vue?vue&type=script&lang=js&"
export * from "./DebtTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports